export function isBreastOrOvarian(id: string) {
  return ['bbba0e5c-5b67-44aa-aa8e-fba915a2b810', 'TODO-ADD OVARIAN WHEN CREATED'].includes(id);
}

export function isExplicitlyMale(id: string) {
  return ['92cca881-8aee-48e1-981b-ac8f0e6e19e2', '35ef9920-06ea-4486-b5ca-e8d95bdc4ae7'].includes(
    id
  );
}

export function showBreastCancerFields(cancerTypeId: string, sexId: string) {
  return isBreastOrOvarian(cancerTypeId) && !isExplicitlyMale(sexId);
}
